import type { BookingMutationInput } from "./types";

const IDEMPOTENCY_KEY = /^[a-z0-9][a-z0-9._:-]{7,79}$/i;

export function isValidIdempotencyKey(value: string): boolean {
  return IDEMPOTENCY_KEY.test(value);
}

export function bookingFingerprint(
  input: Pick<BookingMutationInput, "sessionId" | "slot">,
): string {
  return `${input.sessionId.trim()}\u0000${input.slot.trim()}`;
}
